import { handleActions } from 'redux-actions'
import {
  SET_HOT_SALE_DATA,
  SET_HOT_SALE_STATE
} from '../constants/mallConstant'
import { handleStateChange } from '../utils'

const initState = {
  loading: false,
  errorMessage: '',
  data: []
}

export const mallHotSale = handleActions({
  [SET_HOT_SALE_STATE]: handleStateChange,
  [SET_HOT_SALE_DATA]: (state, action) => {
    // todo keymap
    return {
      ...state,
      loading: false,
      errorMessage: '',
      data: action.payload.list
    }
  }
}, initState)
